import * as React from "react";

import type { KeyValue, PageEnvelope } from "@skv/core";
import { Analytics, HelmetCanonical } from "@skv/core";

import { useAppSettings, usePageEnvelope } from "@skv/state";

import { DefaultTheme, withTheme } from "styled-components";

import { ActivityDashboard } from "~/ui/ActivityDashboard";

interface HomeViewModel {
  majorCities?: MajorCity[];
  opportunityFilters?: OpportunityFilters;
}

interface OpportunityFilters {
  categoryList: KeyValue[];
  commitmentList: KeyValue[];
  dayAndTimeList: KeyValue[];
  suitableForList: KeyValue[];
  typeOfWorkList: KeyValue[];
}

interface MajorCity {
  name: string;
  url: string;
  value: string;
}

interface State {
  loading: boolean;
  error: null | Error;
  data: HomeViewModel;
}

interface HomeProps {
  theme: DefaultTheme;
}

let HOME_VIEW_MODEL_CACHE: HomeViewModel = null;

const Home: React.FC<HomeProps> = ({ theme }) => {
  const { pageEnvelope } = usePageEnvelope<HomeViewModel>();

  const { applicationUrl } = useAppSettings();

  const [state, setState] = React.useState<State>((): State => {
    if (pageEnvelope.data) {
      HOME_VIEW_MODEL_CACHE = pageEnvelope.data;

      return {
        loading: false,
        error: null,
        data: pageEnvelope.data,
      };
    }

    return {
      loading: !HOME_VIEW_MODEL_CACHE,
      error: null,
      data: HOME_VIEW_MODEL_CACHE || null,
    };
  });

  React.useEffect(() => {
    if (state.loading) {
      fetch("/api/home")
        .then<PageEnvelope<HomeViewModel>>((res) => {
          if (res.ok) {
            return res.json();
          }
          throw new Error("500");
        })
        .then(({ success, data }) => {
          if (success) {
            setState((prev) => ({
              ...prev,
              loading: false,
              error: null,
              data,
            }));

            HOME_VIEW_MODEL_CACHE = data;
            return;
          }
          throw new Error("500");
        })
        .catch((err) => {
          setState((prev) => ({
            ...prev,
            error: err,
            loading: false,
          }));
        });
    }
  }, []);

  return (
    <>
      <HelmetCanonical url={applicationUrl} />
      <div className="pb-5 pt-3">
        <ActivityDashboard />
      </div>

      <Analytics
        data={{
          subSection: "home",
          subSubSection: "home",
          subSubSubSection: "home",
          pageTitle: "home",
          pageType: "home",
        }}
      />
    </>
  );
};

export default withTheme(Home);
